module.exports = __webpack_public_path__ + "img/laptop-template-ru.0e850d6d.png";